// extracted by mini-css-extract-plugin
export default {"loaderContainer":"styles_loaderContainer__nnZU2","milestonesProgressContainer":"styles_milestonesProgressContainer__FRMKp","headerText":"styles_headerText__Geyuk"};